import type { Editor } from '../editor.ts';
import type { Tool, WorldPointerEvent } from './types.ts';

export class HandTool implements Tool {
  cursor = 'grab';
  private readonly ed: Editor;
  private last: [number, number] | null = null;

  constructor(editor: Editor) {
    this.ed = editor;
  }

  onPointerDown(e: WorldPointerEvent): void {
    this.last = [e.sx, e.sy];
    this.setCursor('grabbing');
  }

  onPointerMove(e: WorldPointerEvent): void {
    if (!this.last) {
      // Audio players can be played with the hand tool too (spec §19.2): show that they're clickable.
      const over = !!this.ed.audioControlAt(e.x, e.y);
      if (over !== (this.cursor === 'pointer')) this.setCursor(over ? 'pointer' : 'grab');
      return;
    }
    this.ed.camera.panBy(e.sx - this.last[0], e.sy - this.last[1]);
    this.last = [e.sx, e.sy];
  }

  onPointerUp(): void {
    this.onCancel();
  }

  onCancel(): void {
    this.last = null;
    this.setCursor('grab');
  }

  private setCursor(c: string): void {
    this.cursor = c;
    this.ed.refreshCursor();
  }
}
